<template>
  <transition>
    <div class="contextmenu-container" v-show="show" :style="{ top: position.y + 'px', left: position.x + 'px' }">
      <ul class="menu-list">
        <li class="menu-item" v-for="(item, i) in list" :key="i + 'item'" @click="item.onClick">
          <span :class="item.icon"></span>
          <div class="menu-label">{{ item.label }}</div>
        </li>
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'ContextMenu',
  props: {
    list: {
      required: true,
      type: Array,
    },
    // 显示/隐藏菜单
    show: {
      required: true,
      type: Boolean,
    },
    // 菜单位置
    position: Object,
  },
}
</script>

<style lang="less" scoped>
.contextmenu-container {
  position: absolute;
  top: 0;
  left: 0;
  transform: translateY(-10%);
  width: 200px;
  padding: 0.8vh 0.4vw;
  background-color: #fff;
  box-shadow: 0 0 12px 10px rgba(0, 0, 0, 0.06);
  border-radius: 15px;

  .menu-list {
    .menu-item {
      cursor: pointer;
      display: flex;
      padding: 0.8vh 0.4vw;
      align-items: center;
      border-radius: 10px;

      &:hover {
        background-color: rgba(0, 0, 255, 0.08);
        color: #296dea;
      }

      .menu-label {
        padding-left: 0.4vw;
      }
    }

    .menu-item:last-child {
      &:hover {
        background-color: rgba(0, 0, 255, 0.08);
        color: red;
      }
    }
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
